/* global axios */
import ApiClient from './ApiClient';

class MetaLeadFormsAPI extends ApiClient {
  constructor() {
    super('meta_lead_forms', { accountScoped: true });
  }

  forms(pageId) {
    return axios.get(`${this.url}/forms`, { params: { page_id: pageId } });
  }

  // Self-serve: busca UM form pelo ID -> devolve página + campos + mapeamento sugerido.
  fetchForm(formId) {
    return axios.get(`${this.url}/fetch_form`, { params: { form_id: formId } });
  }

  metrics(params) {
    return axios.get(`${this.url}/metrics`, { params });
  }

  defaults() {
    return axios.get(`${this.url}/defaults`);
  }

  // Dashboard de leads de UM formulário: { totals, by_day, leads }.
  leads(id, params) {
    return axios.get(`${this.url}/${id}/leads`, { params });
  }

  // CSV (blob) dos leads do formulário — o componente baixa via URL de objeto.
  leadsCsv(id, params) {
    return axios.get(`${this.url}/${id}/leads_csv`, { params, responseType: 'blob' });
  }
}

export default new MetaLeadFormsAPI();
